import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {AwsService} from '../../services/aws.service';
import {BaseClientComponent} from '../base-client.component';

@Component({
  selector: 'app-counters-mqtt',
  templateUrl: './time-sync-mqtt.component.html',
  styleUrls: ['./time-sync-mqtt.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TimeSyncMqttComponent extends BaseClientComponent implements OnInit {
  isUserConnected = false;
  sampleTimeSyncMonitoringData: any;
  datetimeFormat = 'medium';
  etreesClientData: any;
  etreesClientDataAsString = '';

  constructor(
    public authenticationService: AuthenticationService,
    protected utilsService: UtilsService,
    protected http: HttpClient,
    public awsService: AwsService,
  ) {
    super();
    this.sampleTimeSyncMonitoringData = [
      {
        'port': 'wr6',
        'client_xco': 'XXXXXXXX2120',
        'wr_service': 'wr-sec-3',
        'protocol': 'WR',
        'date': 1728557792229,
        'Client Service Accuracy Statistics': [
          {
            'tmas_service': 'tmas-sec-1',
            'utc_offset': 0.99,
            'locking_state_to_nist': 0,
            'locking_state_to_nist_text': 'Ok',
            'locking_state_to_neighbor_nist': 0,
            'neighbor_utc_offset': -2.65,
            'client_time_source_status': 0,
            'nb_hops': 3,
            'offset_from_neighbor_nist': 31.816,
            'neighbor_nist_service': 'tmas-cab-1',
            'neighbor_locking_state_to_nist': 0
          }
        ],
        'Client SFP Port Stats': [
          {
            'vcc': 3.2999,
            'rx_pow': -5.944829,
            'tx_pow': -4.89589,
            'detect': 1,
            'tx_bias': 24.309999,
            'temp': 36.039062
          }
        ],
        'Client Link Statistics': [
          {
            'rx_errors': 0,
            'link_status': 0,
            'tx_bytes': 915316348,
            'tx_errors': 0,
            'rx_bytes': 576074631,
            'tx_packets': 9470742,
            'rx_packets': 4601652
          }
        ],
        'Client Service Precision Statistics': [
          {
            'offset_from_master': '0.001',
            'client_global_status': 0
          }
        ]
      },
      {
        'port': 'wr6',
        'client_xco': 'XXXXXXXX2121',
        'wr_service': 'wr-sec-3',
        'protocol': 'WR',
        'date': 1728557792229,
        'Client Service Accuracy Statistics': [
          {
            'tmas_service': 'tmas-sec-1',
            'utc_offset': 0.99,
            'locking_state_to_nist': 0,
            'locking_state_to_nist_text': 'Ok',
            'locking_state_to_neighbor_nist': 0,
            'neighbor_utc_offset': -2.65,
            'client_time_source_status': 0,
            'nb_hops': 3,
            'offset_from_neighbor_nist': 31.816,
            'neighbor_nist_service': 'tmas-cab-1',
            'neighbor_locking_state_to_nist': 0
          }
        ],
        'Client SFP Port Stats': [
          {
            'vcc': 3.2999,
            'rx_pow': -5.944829,
            'tx_pow': -4.89589,
            'detect': 1,
            'tx_bias': 24.309999,
            'temp': 36.039062
          }
        ],
        'Client Link Statistics': [
          {
            'rx_errors': 0,
            'link_status': 0,
            'tx_bytes': 915316348,
            'tx_errors': 0,
            'rx_bytes': 576074631,
            'tx_packets': 9470742,
            'rx_packets': 4601652
          }
        ],
        'Client Service Precision Statistics': [
          {
            'offset_from_master': '0.001',
            'client_global_status': 0
          }
        ]
      }
    ];
  }

  ngOnInit() {
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.loadData();
    });
    this.subscriptions.push(response$);
  }

  private loadData() {
    this.isUserConnected = true;
    this.awsService.updateAwsTimeSyncParametersFromServer().then(() => {
    });
    this.utilsService.lockUi();
    this.awsService.loadEtreesForClientDisplay().subscribe({
      next: (response) => {
        this.etreesClientData = response;
        this.etreesClientDataAsString = JSON.stringify(this.etreesClientData);
        this.utilsService.unlockUi();
      },
      error: () => {
        this.utilsService.unlockUi();
        this.utilsService.displayMessage('The E-Trees could not be loaded', 'Please try again later.', 'error');
      }
    });
  }
}
